module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"media_summary_title":"照片&视频","show_all":"全部视图"}}')
  delete Component.options._Ctor
}
